<template>
	<div class="main-logged-view">
		<v-container fluid pl-5>
			<div>
				<h1 class="main-title-logged-view mb-4">Witamy w aplikacji eGranty!</h1>
			</div>
			<v-layout row>
				<v-spacer/>
				<div class="buttons-container">
					<div v-if="roles.isBidder() || roles.isSubBidder() || roles.isAgencyEmployee()">
						<v-btn color="blue" @click="showList()" class="mb-2 d-block" 
							   :title="roles.isAgencyEmployee() ? 'Przejdź do listy naborów' : 'Przejdź do listy konkursów'">
							Złóż {{roles.isAgencyEmployee() ? "wniosek" : "ofertę"}}
						</v-btn>
					</div>
					<v-btn color="blue" outlined @click="downloadRegulations()" class="mb-2 d-block" 
						   title="Pobierz regulamin aplikacji">
						Regulamin
					</v-btn>
					<v-btn color="blue" outlined @click="openContactPage()" class="d-block"
						   title="Przejdź do formularza kontaktu">
						Kontakt
					</v-btn>
				</div>
			</v-layout>
			<div class="title-main-logged-view">
				<div class="title" v-if="roles.isBidder() || roles.isSubBidder()">Powiadomienia:</div>
				<div class="title" v-else>Zadania do wykonania:</div>
			</div>

			<div class="ml-5 mt-3" style="color: #B7B7B7"
				v-if="todos.length === 0 && (roles.isBidder() || roles.isSubBidder())">Brak powiadomień
			</div>
			<div class="ml-5 mt-3" style="color: #B7B7B7"
				v-if="todos.length === 0 && (!roles.isBidder() && !roles.isSubBidder())">Brak zadań
			</div>

			<v-layout v-for="(todo, index) in todos" :key="index" ma-3 align-center>
				<v-icon class="ml-3 mr-3" style="margin: 15px">
					lens
				</v-icon>
				<a :href="getTodoPath(todo)" :class="styleclass[index]">{{getTodoText(todo.type, todo.metaText,
					todo.creationDate)}}</a>
				<v-icon class="ml-5 mr-3" style="margin: 15px" @click="removeTodoTask(todo.id)">
					clear
				</v-icon>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
	import {Todos} from "@/api/generated/Todos";

	export default {
		name: "MainLoggedView",

		data() {
			return {
				publicPath: process.env.BASE_URL,
				todos: [],
				styleclass: [],
			};
		},

		methods: {
			openContactPage() {
				this.$router.push({name: "contact"});
			},
			downloadRegulations() {
				const link = document.createElement('a');
				link.href = `${this.publicPath}eGranty - regulamin_aplikacji.pdf`;
				link.download = 'eGranty - regulamin_aplikacji.pdf';
				link.click();
			},
			loadTodos() {
				Todos.get(this, response => {
					this.todos = response.sort((t1, t2) => t2.creationDate.localeCompare(t1.creationDate));
					this.styleclass.length = this.todos.length;
					this.styleclass.fill("");
				});
			},

			getTodoText(type, metaText, date) {
				let text = null;
				switch (type) {
					case "UNACCEPTED_USER":
						text = "Nowy użytkownik czeka na zaakceptowanie ";
						break;
					case "PC_AGENCY_EVALUATION":
						text = "Opinia placówki do wypełnienia";
						break;
					case "PC_COLLABORATION_EVALUATION":
						text = "Opinia współpracy do wypełnienia";
						break;
					case "PC_EXPERT_EVALUATION":
						text = "Opinia ekspercka do wypełnienia";
						break;
					case "PC_FINAL_EVALUATION":
						text = "Opinia końcowa do wypełnienia";
						break;
					case "PC_FORMAL_EVALUATION":
						text = "Opinia formalna do wypełnienia";
						break;
					case "PC_SUBSTANTIVE_EVALUATION":
						text = "Indywidualna opinia członka komisji do wypełnienia";
						break;
					case "AC_EXPERT_EVALUATION":
						text = "Opinia ekspercka do wypełnienia";
						break;
					case "AC_FINAL_EVALUATION":
						text = "Opinia końcowa do wypełnienia";
						break;
					case "AC_SUBSTANTIVE_EVALUATION":
						text = "Indywidualna opinia członka zespołu do wypełnienia";
						break;
					case "OFFER_WAITING_FOR_ACCEPTANCE":
						text = "Oferta do zaakceptowania";
						break;
					case "OFFER_CORRECTION_NEEDED":
						text = "Oferta czekająca na poprawki";
						break;
					case "OFFER_MAIN_BIDDER_REJECTED":
						text = "Oferta niezaakceptowana przez konto nadrzędne";
						break;
					case "OFFER_MUTUAL_BIDDER_REJECTED":
						text = "Oferta niezaakceptowana przez współoferenta";
						break;
          case "PROJECT_WAITING_FOR_ACCEPTANCE":
            text = "Projekt do zaakceptowania";
            break;
          case "PROJECT_MAIN_BIDDER_REJECTED":
            text = "Projekt niezaakceptowany przez głównego oferenta";
            break;
          case "REPORT_WAITING_FOR_ACCEPTANCE":
            text = "Sprawozdanie do zaakceptowania";
            break;
          case "REPORT_MAIN_BIDDER_REJECTED":
            text = "Sprawozdanie niezaakceptowane przez głównego oferenta";
            break;
					case "AGENCY_PROJECT_CORRECTION_NEEDED":
						text = "Wniosek czekający na poprawki";
						break;
					case "AGENCY_APPROVED_PROJECT_CORRECTION_NEEDED":
						text = "Projekt czekający na poprawki";
						break;
					case "PC_AGENCY_EVALUATION_REVISION":
						text = "Opinia placówki do poprawki";
						break;
					case "PC_COLLABORATION_EVALUATION_REVISION":
						text = "Opinia współpracy do poprawki";
						break;
					case "PC_EXPERT_EVALUATION_REVISION":
						text = "Opinia ekspercka do poprawki";
						break;
					case "PC_FINAL_EVALUATION_REVISION":
						text = "Opinia końcowa do poprawki";
						break;
					case "PC_FORMAL_EVALUATION_REVISION":
						text = "Opinia formalna do poprawki";
						break;
					case "PC_SUBSTANTIVE_EVALUATION_REVISION":
						text = "Indywidualna opinia członka komisji do poprawki";
						break;
					case "AC_EXPERT_EVALUATION_REVISION":
						text = "Opinia ekspercka do poprawki";
						break;
					case "AC_FINAL_EVALUATION_REVISION":
						text = "Opinia końcowa do poprawki";
						break;
					case "AC_SUBSTANTIVE_EVALUATION_REVISION":
						text = "Indywidualna opinia członka zespołu do poprawki";
						break;
					case "PC_AGENCY_EVALUATION_INAPPROPRIATE":
						text = "Opinia placówki - nieprawidłowe przypisanie";
						break;
					case "PC_COLLABORATION_EVALUATION_INAPPROPRIATE":
						text = "Opinia współpracy - nieprawidłowe przypisanie";
						break;
					case "PC_EXPERT_EVALUATION_INAPPROPRIATE":
						text = "Opinia ekspercka - nieprawidłowe przypisanie";
						break;
					case "PC_FINAL_EVALUATION_INAPPROPRIATE":
						text = "Opinia końcowa - nieprawidłowe przypisanie";
						break;
					case "PC_FORMAL_EVALUATION_INAPPROPRIATE":
						text = "Opinia formalna - nieprawidłowe przypisanie";
						break;
					case "PC_SUBSTANTIVE_EVALUATION_INAPPROPRIATE":
						text = "Indywidualna opinia członka komisji - nieprawidłowe przypisanie";
						break;
					case "AC_EXPERT_EVALUATION_INAPPROPRIATE":
						text = "Opinia ekspercka - nieprawidłowe przypisanie";
						break;
					case "AC_FINAL_EVALUATION_INAPPROPRIATE":
						text = "Opinia końcowa - nieprawidłowe przypisanie";
						break;
					case "AC_SUBSTANTIVE_EVALUATION_INAPPROPRIATE":
						text = "Indywidualna opinia członka zespołu - nieprawidłowe przypisanie";
						break;
					case "PROJECT_CORRECTION_NEEDED":
						text = "Projekt do poprawki";
						break;
					case "FINAL_REPORT_CORRECTION_NEEDED":
						text = "Sprawozdanie końcowe do poprawki";
						break;
					case "AGENCY_FINAL_REPORT_CORRECTION_NEEDED":
						text = "Sprawozdanie końcowe do poprawki";
						break;
					case "VOLUNTEER_REPORT_TODO":
						text = "Raport wolontariusza do wykonania";
						break;
					case "VOLUNTEER_REPORT_CORRECTION_NEEDED":
						text = "Raport wolontariusza do poprawki";
						break;
				}
				if (metaText) {
					return date + " " + text + " (" + metaText + ")";
				} else {
					return date + " " + text;
				}
			},

			getTodoPath(todo) {
				switch (todo.type) {
					case "UNACCEPTED_USER":
						return "bidders";
					case "PC_AGENCY_EVALUATION":
						return "evaluations/agency";
					case "PC_EXPERT_EVALUATION":
						return "evaluations/expert";
					case "PC_FINAL_EVALUATION":
						return "evaluations/final";
					case "PC_FORMAL_EVALUATION":
						return "evaluations/formal";
					case "PC_SUBSTANTIVE_EVALUATION":
						return "evaluations/substantive";
					case "AC_EXPERT_EVALUATION":
						return "agency-evaluations/expert";
					case "AC_FINAL_EVALUATION":
						return "agency-evaluations/final";
					case "AC_SUBSTANTIVE_EVALUATION":
						return "agency-evaluations/substantive";
					case "PC_AGENCY_EVALUATION_REVISION":
						return "evaluations/agency";
					case "PC_EXPERT_EVALUATION_REVISION":
						return "evaluations/expert";
					case "PC_FINAL_EVALUATION_REVISION":
						return "evaluations/final";
					case "PC_FORMAL_EVALUATION_REVISION":
						return "evaluations/formal";
					case "PC_SUBSTANTIVE_EVALUATION_REVISION":
						return "evaluations/substantive";
					case "AC_EXPERT_EVALUATION_REVISION":
						return "agency-evaluations/expert";
					case "AC_FINAL_EVALUATION_REVISION":
						return "agency-evaluations/final";
					case "AC_SUBSTANTIVE_EVALUATION_REVISION":
						return "agency-evaluations/substantive";
					case "OFFER_CORRECTION_NEEDED":
						return "bidder-offers";
					case "AGENCY_PROJECT_CORRECTION_NEEDED":
						return "all-agency-offers";
					case "AGENCY_APPROVED_PROJECT_CORRECTION_NEEDED":
						return "approved-agency-projects";
					case "AGENCY_FINAL_REPORT_CORRECTION_NEEDED":
						return "approved-agency-projects";
          case "PROJECT_CORRECTION_NEEDED":
          case "FINAL_REPORT_CORRECTION_NEEDED":
					case "OFFER_WAITING_FOR_ACCEPTANCE":
					case "PROJECT_WAITING_FOR_ACCEPTANCE":
					case "REPORT_WAITING_FOR_ACCEPTANCE":
					default:
						return todo.pathToAction;
				}
			},

			removeTodoTask (id) {
				this.$confirm("Czy na pewno chcesz usunąć to powiadomienie? Związane z nim działanie nie zostało jeszcze wykonane.", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie powiadomienia",
					width: 500
				})
					.then(res => {
						if (res) {
							Todos.delete(this, id, successResponse => {
									this.loadTodos();
									this.$messagesBus.$emit("success", "Powiadomienie zostało pomyślnie usunięte", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć powiadomienia", errorResponse);
								});
						}
					});
			},

			showList() {
				if (this.roles.isAgencyEmployee()) {
					this.$router.push("/app/agency-contest/list");
				}
				if (this.roles.isBidder() || this.roles.isSubBidder()) {
					this.$router.push("/app/contest/list");
				}
			},
		},

		created() {
			this.loadTodos();
		},
	};
</script>

<style scoped>
	.deleted {
		color: grey;
		text-decoration: line-through;
	}

	.main-logged-view .title-main-logged-view .title {
		font-family: 'Open Sans', sans-serif !important;
	}

	.application.mediumFont .title {
		font-size: 22px !important;
	}

	.application.largeFont .title {
		font-size: 40px !important;
	}

	.main-title-logged-view {
		font-family: 'Open Sans', sans-serif;
		font-size: 28px;
		text-align: center;
		color: #0052A5;
	}

	.theme--dark .main-title-logged-view {
		color: #fff;
	}

	.application.mediumFont .main-title-logged-view {
		font-size: 2em;
	}

	.application.largeFont .main-title-logged-view, .application.largeFont .title {
		font-size: 3.2em;
	}

	.buttons-container {
		text-align: right;
	}

	.buttons-container .v-btn.d-block {
		display: block;
		margin-left: auto;
	}

</style>
